let language = {
    "PAYPAL_PAYMENT_FAILED_TITLE": "Paypal免密码支付失败",
    "PAYPAL_DECLINED_TRANSACTION_TITLE": "PayPal付款失败",

    "CHECK_PASSWORD_PAYMENT_SETTING": "您的 PayPal 免密码付款失败。请断开连接并刷新页面重试。",
    "CHECK_PAYMENT_SETTING": "请检查您的 PayPal 账户设置；我们目前无法连接到您的 PayPal 账户进行付款。",
    "CHECK_PAYMENT_SETTING_OR_ACCOUNT_BALANCE": "您的帐户似乎无法连接或余额不足，因此我们目前无法连接您的PayPal帐户进行付款。",
    "TRY_PAYMENT_AGAIN": "PayPal付款失败，请稍后重试",
    "PAYPAL_REDIRECTION_FAILED_TITLE": "PayPal重定向失败",
    "PAYPAL_REDIRECTION_FAILED_CONTENT": "哦，payPal支付重定向失败，请稍后再试。 ",
};

export { language }